import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../Compliance/AgGrid';
import { TaxAccessSyncLogRepository } from '../taxAccessSyncLog.repository';

export class TaxAccessSyncLogListAgGridDataSource extends AgGridDataSourceBase<void> {
    constructor(
        readonly gridApi: GridApi,
        private readonly _taxAccessSyncLogRepository: TaxAccessSyncLogRepository
    ) {
        super(gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.TaxAccessSyncSummaryLogPropertyEnum>[] = [
        { name: 'taxAccessSyncSummaryLogId', value: Core.TaxAccessSyncSummaryLogPropertyEnum.TaxAccessSyncSummaryLogId },
        { name: 'batchId', value: Core.TaxAccessSyncSummaryLogPropertyEnum.BatchId },
        { name: 'runType', value: Core.TaxAccessSyncSummaryLogPropertyEnum.RunType },
        { name: 'runStatus', value: Core.TaxAccessSyncSummaryLogPropertyEnum.RunStatus },
        { name: 'startTimeUtc', value: Core.TaxAccessSyncSummaryLogPropertyEnum.StartTimeUtc },
        { name: 'endTimeUtc', value: Core.TaxAccessSyncSummaryLogPropertyEnum.EndTimeUtc },
        { name: 'processedCount', value: Core.TaxAccessSyncSummaryLogPropertyEnum.ProcessedCount },
        { name: 'sentCount', value: Core.TaxAccessSyncSummaryLogPropertyEnum.SentCount },
        { name: 'skippedCount', value: Core.TaxAccessSyncSummaryLogPropertyEnum.SkippedCount },
        { name: 'failedCount', value: Core.TaxAccessSyncSummaryLogPropertyEnum.FailedCount },
        { name: 'unmappedCount', value: Core.TaxAccessSyncSummaryLogPropertyEnum.UnmappedCount }
    ];

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.TaxAccessSyncSummaryLogSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap)
        };

        const result = await lastValueFrom(this._taxAccessSyncLogRepository.getList(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows
        } as AgGridDataSourceResult;
    }
}
